export default __webpack_public_path__ + "static/media/Logo.f5a282b4.svg";